/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:66e7f558-e506-4407-a006-8a7c2e3d84df",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_rEVA3p9o4",
    "aws_user_pools_web_client_id": "28d6elkckfnm532qp60v3nutag",
    "oauth": {}
};


export default awsmobile;
